import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Typography, Tooltip } from '@mui/material_modern'
import TimerSharpIcon from '@mui/icons-material_modern/TimerSharp'

const PaymentWarning = ({ id, isRestricted, materialName, restrictedThroughDate, isMultiple, multipleTooltipText }) => {
  if (!isRestricted) return null
  return (
    <Stack direction="row" mb={2} key={id} alignItems="center">
      <TimerSharpIcon color="warning" mr={2} />
      {isMultiple ? (
        <Tooltip title={multipleTooltipText}>
          <Typography ml={1} mr={1}>
            MULTIPLE
          </Typography>
        </Tooltip>
      ) : (
        <Typography ml={1} mr={1}>
          {materialName.toUpperCase()}
        </Typography>
      )}
      <Typography variant="caption">Hold through {restrictedThroughDate}</Typography>
    </Stack>
  )
}

PaymentWarning.propTypes = {
  id: PropTypes.string.isRequired,
  isRestricted: PropTypes.bool,
  materialName: PropTypes.string,
  restrictedThroughDate: PropTypes.string,
  isMultiple: PropTypes.bool,
}

PaymentWarning.defaultProps = {
  isRestricted: false,
  materialName: '',
  restrictedThroughDate: '',
  isMultiple: false,
}

export default PaymentWarning
